<form [formGroup]="viewDialogForm">
  <h3
    mat-dialog-title
    class="!flex !flex-row !content-between !p-6 !items-center"
  >
    <span class="!grow grid-view-dialog__header">{{
      dialogProps.gridHeader
    }}</span>
    <button mat-icon-button class="close-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h3>
  <mat-dialog-content class="!p-6">
    @if (
      dialogProps.viewAction === "Save" || dialogProps.viewAction === "Create"
    ) {
      <ng-container [ngTemplateOutlet]="singleView"/>
    }
    @if (dialogProps.viewAction === "Edit") {
      <ng-container [ngTemplateOutlet]="arrayView"/>
    }
    @if (dialogProps.viewAction === "Update") {
      <p class="grid-view-dialog__content-update-text">
        Are you sure you want to update Custom View?
      </p>
    }
  </mat-dialog-content>
  <mat-dialog-actions class="!p-6" align="end">
    <wcg-button
      wcg-button
      color="tertiary"
      class="save-grid-view__button-cancel outline-btn"
      (click)="close()"
    >
      Cancel
    </wcg-button>
    <wcg-button
      color="primary"
      (click)="saveEditGridView()"
      class="save-grid-view__button-save"
      [isDisabled]="!viewDialogForm.valid"
    >
      {{ dialogProps.gridBtnLabel }}
    </wcg-button>
  </mat-dialog-actions>

  <ng-template #singleView>
    <mat-label class="grid-view-dialog__label-message text-sm"
      >View Name</mat-label
    >
    <mat-form-field appearance="outline" class="w-full">
      <input matInput formControlName="gridNames" required />
      @if (viewDialogForm.controls.gridNames.hasError("required")) {
        <mat-error class="!flex !items-center absolute left-0">
          <mat-icon>info</mat-icon>
          <span class="grid-view-dialog__error-message"
            >Please enter a name</span
          >
        </mat-error>
      }
      @if (viewDialogForm.controls.gridNames.hasError("minTrimmedLength")) {
        <mat-error class="!flex !items-center absolute left-0">
          <mat-icon>info</mat-icon>
          <span class="grid-view-dialog__error-message">
            Name must be at least 3 characters long
          </span>
        </mat-error>
      }
      @if (viewDialogForm.controls.gridNames.hasError("serverError")) {
        <mat-error class="!flex !items-center absolute left-0">
          <mat-icon>info</mat-icon>
          This name already exists
        </mat-error>
      }
    </mat-form-field>
  </ng-template>

  <!--@Todo For Edit View--->
  <ng-template #arrayView>
    <div class="flex flex-col gap-6" formArrayName="gridNames">
      @if (gridNames().length > 0) {
        @for (
          control of gridNames().controls;
          track control;
          let i = $index;
          let last = $last
        ) {
          <ng-container [formGroupName]="i">
            <span class="flex gap-2">
              <mat-form-field appearance="outline" class="w-full">
                <input
                  matInput
                  [formControl]="control.controls.name"
                  required
                />
                @if (control.controls.name.hasError("required")) {
                  <mat-error class="!flex !items-center absolute left-0">
                    <mat-icon>info</mat-icon>
                    <span class="grid-view-dialog__error-message"
                      >Please enter a name</span
                    >
                  </mat-error>
                }
                @if (control.controls.name.hasError("minTrimmedLength")) {
                  <mat-error class="!flex !items-center absolute left-0">
                    <mat-icon>info</mat-icon>
                    <span class="grid-view-dialog__error-message"
                      >Name must be at least 3 characters long</span
                    >
                  </mat-error>
                }
                @if (control.controls.name.hasError("serverError")) {
                  <mat-error class="!flex !items-center absolute left-0">
                    <mat-icon>info</mat-icon>
                    This name already exists
                  </mat-error>
                }
              </mat-form-field>
              <mat-icon
                class="grid-view-dialog__delete-icon"
                (click)="deleteGridView(i)"
                >delete_outline</mat-icon
              >
            </span>
            @if (!last) {
              <mat-divider></mat-divider>
            }
          </ng-container>
        }
      } @else {
        <p class="grid-view-dialog__no-names-message">
          There are no custom views to edit
        </p>
      }
    </div>
  </ng-template>
  <!--/@Todo For Edit View--->
</form>
